import angular from 'angular';
import aeInformationComponent from './information.component';

export default angular.module('components.app.adverseEvent.information', [])
  .component('adverseEventInformation', aeInformationComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/information/information.module.js